module.exports = __webpack_public_path__ + "static/media/enfriamiento.7c638417.jpg";